import React,{ useEffect }  from 'react';
import { useLocation } from 'react-router-dom';
import './Service.css'
import service from '../../assets/images/Service.png'
import service1 from '../../assets/images/Service1.png'
import banner from '../../assets/images/service banner.png'
import medical from '../../assets/images/medical-school.png'
import consent from '../../assets/images/consent.png'
import patient from '../../assets/images/patient.png'
import aos from 'aos';
import 'aos/dist/aos.css'
const Service = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);
  return (
    <>

    {/* Start Service Section  */}
    <div className="container-fluid gx-0">
      <div className="row gx-0">
        <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
      </div>
    </div>
    <div className="container py-lg-5 py-sm-3">
      <div className="row">
        <div className="col-12">
          <p className='px-lg-5 mb-lg-5 mb-3 top-content' data-aos="zoom-in">At Oreus Lifesciences, we offer a wide range of services to support the pharmaceutical ecosystem, encompassing doctors, logistic partners, and patients.</p>
        </div>
      </div>
      <div className="row">
        <h4 className='main-heading mb-lg-5' data-aos="zoom-in">Services for Doctors</h4>
        <div className="col-lg-4 col-md-4 col-sm-6">
           <div className="card p-lg-3 service-card service-card-top" data-aos="zoom-in">
           <div className="text-center mb-lg-3">
           <img className='img-fluid' src={medical} alt="" />
           </div>
            <h5 className='main-heading'>Academic Support Services</h5>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Continuing Medical Education (CME) programs</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Clinical research and trial support</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Medical literature updates</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Expert opinion and advisory services</p>
           </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
        <div className="card p-lg-3 service-card service-card-top" data-aos="zoom-in">
        <div className="text-center mb-lg-3">
           <img className='img-fluid' src={consent} alt="" />
           </div>
            <h5 className='main-heading'>Medical Information Services</h5>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Product information and query resolution</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Adverse event reporting and pharmacovigilance</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Medical conference and event support</p>
            
           </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
        <div className="card p-lg-3 service-card service-card-top" data-aos="zoom-in">
        <div className="text-center mb-lg-3">
           <img className='img-fluid' src={patient} alt="" />
           </div>
            <h5 className='main-heading'>Practice Support Services</h5>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Patient management and retention strategies</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Practice marketing and promotional support</p>
            <p><span><i className="bi bi-arrow-right-short"></i></span>Medical writing and publication assistance</p>
            
           </div>
        </div>
      </div>
    </div>
    {/* End Service Section  */}

    {/* Start Services for Logistic Partners  */}
    
    <div className="container py-lg-5 py-sm-3">
      <div className="row"><hr/>
        <h1 className='main-heading mt-5' data-aos="zoom-in">Services for Logistic Partners</h1>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={service} alt="" />
        </div>
        <div className="col-lg-6 col-md-6">
          <div className="logistic-partner-content" data-aos="zoom-in">
          <h5>Wholesaler and Retailer Support</h5>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Order management and fulfilment</p>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Inventory management and logistics support</p>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Credit and payment solutions</p>

          <h5 className='mt-lg-5'>Chemist and Pharmacist Support</h5>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Product knowledge and training</p>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Point-of-purchase materials and displays</p>
          <p><span><i className="bi bi-arrow-right-short"></i></span>Customer loyalty programs</p>
          </div>
        </div>
      </div>
    </div>
    {/* End Services for Logistic Partners  */}
      
   {/* Start Services for Patients Section  */}
  
   <div className="container py-lg-5 py-sm-3">
      <div className="row"><hr/>
        <h1 className="main-heading mt-5 " data-aos="zoom-in">Services for Patients</h1>
      </div>
      <div className="row mt-3">
        <div className="col-lg-4 col-md-4 col-sm-6">
           <div className="card p-lg-3 service-card service-patients-card" data-aos="zoom-in">
            <h5 className='mb-3'>Patient Awareness Camps</h5>
            <p>Disease awareness and education</p>
            <p>Health screening and counselling</p>
            <p>Medication adherence support</p>
          
           </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
        <div className="card p-lg-3 service-card service-patients-card" data-aos="zoom-in">
            <h5 className='mb-3'>Patient Literature and Resources</h5>
            <p>Patient information leaflets (PILs)</p>
            <p>Medication guides and instructions</p>
            <p>Disease management and lifestyle advice</p>
            
            
           </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
        <div className="card p-lg-3 service-card service-patients-card" data-aos="zoom-in">
            <h5 className='mb-3'>Patient Support Programs</h5>
            <p>Patient assistance programs (PAPs)</p>
            <p>Reimbursement and insurance support</p>
            <p>Adherence and persistence programs</p>
           
            
           </div>
        </div>
      </div>
    </div>
   {/* End Services for Patients Section  */}

   {/*Start Additional Services Section  */}
   <div className="container py-lg-5 py-sm-3">
    <div className="row"><hr/>
      <h1 className='main-heading mt-5' data-aos="zoom-in">Additional Services</h1>
    </div>
    <div className="row">
      <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center" data-aos="zoom-in">
      <p><span><i className="bi bi-arrow-right-short"></i></span>Market Research and Analytics</p>
      <p><span><i className="bi bi-arrow-right-short"></i></span>Regulatory Affairs and Compliance</p>
      <p><span><i className="bi bi-arrow-right-short"></i></span>Supply Chain Optimisation</p>
      <p className='mt-lg-5'>By offering these comprehensive services, we aim to enhance the pharmaceutical ecosystem, supporting doctors, logistic partners, and patients in their respective roles.</p>
      </div>
      <div className="col-lg-6 col-md-6">
        <img className='img-fluid' data-aos="zoom-in" src={service1} alt="" />
      </div>
    </div>
   </div>
   {/*End Additional Services Section  */}
    </>
  )
}

export default Service;
